import { type EventEnrichment } from '@/shared/services/analytics/analytics-service';
import { type URL_SOURCES } from '@/shared/services/analytics/types';

export enum StartAppUtil {
  RESET = 'reset', // reset token in cookie. For qa
}

export interface StartAppArgs {
  path?: string | null;
  src?: URL_SOURCES;
  telegram_id?: string;
  enrich_event?: EventEnrichment;
  util?: StartAppUtil;
  otp?: string;
  prize_id?: string;
  ref?: string;
  labels?: string[];
  preparedInlineMessageId?: string;
  gameKey?: string;
}

interface BackButton {
  customAction: null | (() => void);
}

export interface TgState {
  actions: TgStateActions;
  isFullscreen: boolean;
  initURLHash: string;
  startAppArgs: StartAppArgs;
  backButton: BackButton;
}

export interface TgStateActions {
  hydrate: (fresh: Partial<TgState>) => void;
  updateStartappArgs: (args: Partial<StartAppArgs>) => void;
  updateBackButton: (args: Partial<BackButton>) => void;
}
